
import React from 'react';
import ThreadCard from './ThreadCard';
import { Thread } from './types';

interface ThreadsListProps {
  threads: Thread[];
  onLikeThread: (threadId: string, isCurrentlyLiked: boolean) => void;
}

const ThreadsList: React.FC<ThreadsListProps> = ({ threads, onLikeThread }) => {
  return (
    <div className="space-y-4">
      {threads.map((thread) => (
        <ThreadCard 
          key={thread.id} 
          thread={thread} 
          onLikeThread={onLikeThread}
        />
      ))}
    </div>
  );
};

export default ThreadsList;
